import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import extractText from 'flarum/common/utils/extractText';

/**
 * Grid view: a kebab menu on each card exposing the standard discussion
 * controls (rename, delete, subscribe, tag, …) that the card layout
 * otherwise hides. The popup is rendered into a fixed-position element on
 * document.body so it can't be clipped by the card's overflow/rounding, and
 * its items come straight from DiscussionControls so nothing re-implements
 * policy — an empty item list means no button at all.
 */

let openMenu = null;
let outsideListener = null;
function closeMenu() {
  if (openMenu) {
    m.render(openMenu, null);
    openMenu.remove();
    openMenu = null;
  }
  if (outsideListener) {
    document.removeEventListener('click', outsideListener, true);
    outsideListener = null;
  }
}
function showMenu(button, component, d) {
  closeMenu();
  const items = DiscussionControls.controls(d, component).toArray();
  if (!items.length) return;
  const menu = document.createElement('ul');
  menu.className = 'Dropdown-menu dropdown-menu Bespoke-cardMenu';
  document.body.appendChild(menu);
  m.render(menu, items.map(item => m('li', item)));
  const rect = button.getBoundingClientRect();
  menu.style.position = 'fixed';
  menu.style.display = 'block';
  menu.style.top = Math.min(rect.bottom + 6, window.innerHeight - menu.offsetHeight - 10) + 'px';
  menu.style.left = Math.max(10, Math.min(rect.right - menu.offsetWidth, window.innerWidth - menu.offsetWidth - 10)) + 'px';
  openMenu = menu;
  outsideListener = e => {
    const target = e.target;
    if (menu.contains(target)) {
      setTimeout(closeMenu, 0);
      return;
    }
    if (!button.contains(target)) closeMenu();
  };
  document.addEventListener('click', outsideListener, true);
}
function decorateMenu() {
  const el = this.element;
  const d = this.attrs && this.attrs.discussion;
  if (!el || !d || !app.session.user) return;
  if (el.closest('.DiscussionListPane')) return;
  if (document.documentElement.getAttribute('data-bespoke-discussions') !== 'grid') return;
  if (el.querySelector('.Bespoke-cardMenuBtn')) return;
  try {
    if (!DiscussionControls.controls(d, this).toArray().length) return;
  } catch (e) {
    return;
  }
  const btn = document.createElement('button');
  btn.className = 'Bespoke-cardMenuBtn';
  btn.type = 'button';
  btn.setAttribute('aria-label', extractText(app.translator.trans('ernestdefoe-bespoke.forum.card_menu')));
  btn.innerHTML = '<i class="icon fas fa-ellipsis-v"></i>';
  btn.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();
    if (openMenu) closeMenu();else showMenu(btn, this, d);
  });
  el.appendChild(btn);
}
export default function cardMenu() {
  extend(DiscussionListItem.prototype, 'oncreate', decorateMenu);
  extend(DiscussionListItem.prototype, 'onupdate', decorateMenu);
  extend(DiscussionListItem.prototype, 'onremove', function () {
    closeMenu();
  });
}